exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-holder {\n  padding-left: 10px;\n}\n.icon-holder i {\n  padding-right: 10px;\n}\n", ""]);

// exports
